import {ActiveData} from '../../ActiveData';
import {StageDataEvent} from './stage_data/StageDataEvent';
import {IPointData, PointData} from '../base/PointData';

export class StageData extends PointData
{
    scale: PointData;

    constructor(private stageConfig: IStageData) {
        super(stageConfig);

        this.scale = new PointData(stageConfig.scale);
    }

    get width(): number {
        return this.stageConfig!.width;
    }

    set width(value: number) {
        this.stageConfig!.width = value;
        ActiveData.addEventToPool<number>(this, StageDataEvent.WIDTH_CHANGED, this.stageConfig!.width);
    }

    get height(): number {
        return this.stageConfig!.height;
    }

    set height(value: number) {
        this.stageConfig!.height = value;
        ActiveData.addEventToPool<number>(this, StageDataEvent.HEIGHT_CHANGED, this.stageConfig!.height);
    }
}

export interface IStageData extends IPointData
{
    width: number;
    height: number;
    scale: IPointData
}
